module.exports = __webpack_public_path__ + "img/ic-exclamation-mark-noti.8ae7a5c2.svg";